module.exports = __webpack_public_path__ + "static/media/1012712.a15d2e1f.jpg";